import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DealStatusPickerComponent } from './deal-status-picker/deal-status-picker.component';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { MatDialogModule } from '@angular/material/dialog';
import { DealStatusReasonDialogComponent } from './deal-status-reason-dialog/deal-status-reason-dialog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyModule } from '@ngx-formly/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DealStatusPickerSmartComponent } from './deal-status-picker-smart/deal-status-picker-smart.component';

@NgModule({
  declarations: [
    DealStatusPickerComponent,
    DealStatusReasonDialogComponent,
    DealStatusPickerSmartComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatSelectModule,
    MatTooltipModule,
    ReactiveFormsModule,
    FormlyMaterialModule,
    FormlyModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    DealStatusPickerSmartComponent
  ]
})

export class DealStatusPickerModule { }
